<template>
  <div class="app-template">
    <div class="title">应用模板</div>
    <div class="main">
      <div class="operate">
        <el-input
          class="input-search"
          v-model="searchText"
          size="small"
          placeholder="应用名称"
          clearable
          prefix-icon="el-icon-search"
          @input="search"
        ></el-input>
        <el-button class="button-new" @click="createVisible = true">新建</el-button>
      </div>

      <el-table
        ref="templateTable"
        :data="filterData"
        tooltip-effect="dark"
        v-ps="'.el-table__body-wrapper'"
        height="calc(100vh - 163px)"
        style="margin-top:20px; margin-bottom:-24px"
      >
        <el-table-column
          v-for="column in appTemplateColumns"
          :key="column.value"
          :prop="column.value"
          :label="column.label"
          :width="column.width"
        >
          <template slot-scope="scope">
            <template v-if="column.value === 'name'">
              <div class="app-item">
                <div class="app-icon" :style="{ background: scope.row.color }">
                  <svg-icon
                    :icon-class="scope.row.icon ? 'app_' + scope.row.icon : 'app'"
                  ></svg-icon>
                </div>
                <div class="font-main app-name" v-tip="1">
                  {{ scope.row[column.value] }}
                </div>
              </div>
            </template>
            <template v-else-if="column.value === 'templateInfo.status'">
              <el-tag
                v-if="scope.row.templateInfo.status === '进行中'"
                type="warning"
                effect="dark"
                size="mini"
              >
                进行中
              </el-tag>
              <el-tag
                v-if="scope.row.templateInfo.status === '待发布'"
                type="success"
                effect="dark"
                size="mini"
              >
                待发布
              </el-tag>
              <el-tag v-if="scope.row.templateInfo.status === '已发布'" effect="dark" size="mini">
                已发布
              </el-tag>
            </template>
            <template v-else-if="column.value === 'templateInfo.range'">
              <div v-if="scope.row.templateInfo.range == 'SELF'">本企业</div>
              <div v-else-if="scope.row.templateInfo.range == 'CONNECT'">互联企业</div>
              <div v-else>全网</div>
            </template>
            <template v-else-if="column.value === 'templateInfo.priMode'">
              <div>{{ scope.row.templateInfo.priMode == "OPEN" ? "开放" : "限制" }}</div>
            </template>
            <template v-else>
              <div>{{ _.get(scope.row, column.value) }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="256px">
          <template v-slot="scope">
            <el-button @click.stop="toManageApp(scope.row)" type="text">
              编辑
            </el-button>
            <el-button
              v-if="scope.row.templateInfo.status == '进行中'"
              @click.stop="
                $refs.saveVersionDialog.init(scope.row.id, scope.row.templateInfo.version)
              "
              type="text"
            >
              保存为版本
            </el-button>
            <el-button @click.stop="$refs.historyDialog.init(scope.row)" type="text">
              查看历史版本
            </el-button>
            <el-button
              v-if="scope.row.templateInfo.status == '待发布'"
              @click.stop="publish(scope.row)"
              type="text"
            >
              发布
            </el-button>
            <el-button
              v-if="scope.row.templateInfo.status == '已发布'"
              @click.stop="$refs.deleteTemplateDialog.init(scope.row)"
              type="text"
            >
              删除
            </el-button>
            <dropdown-menu
              v-if="scope.row.templateInfo.status != '已发布'"
              :menu-list="[{ title: '删除', command: 'deleteApp' }]"
              @click="handleTableCommand($event, scope.row)"
              placement="bottom-end"
              style="margin-left: 10px;"
            >
              <span class="pointer">
                <i class="el-icon-more"></i>
              </span>
            </dropdown-menu>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <base-dialog show-close :visible.sync="createVisible">
      <template v-slot:header>新建模板</template>
      <el-form
        class="template-form"
        ref="templateForm"
        :model="templateData"
        :rules="rules"
        label-width="88px"
        hide-required-asterisk
      >
        <el-form-item prop="name">
          <template slot="label">
            模板名称
            <span style="color:red">*</span>
          </template>
          <el-input v-model.trim="templateData.name"></el-input>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            选择应用
            <span style="color:red">*</span>
          </template>
          <el-select v-model="createAppId" style="width:100%" placeholder="请选择">
            <el-option-group v-for="group in createOptions" :key="group.label" :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="模板介绍">
          <el-input v-model="templateData.desc"></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <base-button @click="createVisible = false">取消</base-button>
        <base-button type="primary" @click="createTemplate">确定</base-button>
      </template>
    </base-dialog>
    <save-version-dialog ref="saveVersionDialog" @refresh="refresh"></save-version-dialog>
    <publish-template-dialog
      ref="publishTemplateDialog"
      @refresh="refresh"
    ></publish-template-dialog>
    <history-dialog ref="historyDialog" @refresh="refresh"></history-dialog>
    <delete-template-dialog ref="deleteTemplateDialog" @refresh="refresh"></delete-template-dialog>
    <setting-template-dialog
      ref="settingTemplateDialog"
      @refresh="refresh"
    ></setting-template-dialog>
  </div>
</template>

<script>
import * as appApi from "@/api/userCenter/app"
import { appTemplateColumns } from "./static"
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import DeleteTemplateDialog from "./TemplateDialogs/deleteTemplateDialog"
import HistoryDialog from "./TemplateDialogs/HistoryDialog.vue"
import SaveVersionDialog from "./TemplateDialogs/SaveVersionDialog.vue"
import SettingTemplateDialog from "@/views/Company/Manage/App/TemplateDialogs/SettingTemplateDialog"
import PublishTemplateDialog from "@/views/Company/Manage/App/TemplateDialogs/PublishTemplateDialog"
import { loadingService } from "@/utils/ui"
import { stringIncludes } from "@/utils/common"
export default {
  components: {
    PublishTemplateDialog,
    SettingTemplateDialog,
    BaseDialog,
    BaseButton,
    DropdownMenu,
    DeleteTemplateDialog,
    HistoryDialog,
    SaveVersionDialog
  },
  name: "app-template",
  data() {
    return {
      appTemplateColumns,
      searchText: "",
      historyInput: "",
      filterData: [],
      template: [],
      historyData: [],
      createVisible: false,
      templateData: {
        name: "",
        desc: ""
      },
      createAppId: null,
      createOptions: [
        {
          label: "系统",
          options: [
            {
              value: null,
              label: "空白应用模板"
            }
          ]
        }
      ],
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }]
      }
    }
  },
  created() {
    this.refresh()
    this.getUserAppList()
  },
  methods: {
    refresh() {
      appApi.getCurCompanyAppTemplates().then(res => {
        this.filterData = res
        this.template = res
      })
    },
    getUserAppList() {
      appApi.getAppList("ALL").then(res => {
        let options = res.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
        this.createOptions.push({
          label: "从已有应用新建",
          options: options
        })
      })
    },
    createTemplate() {
      this.$refs.templateForm.validate(valid => {
        if (!valid) return
        let loadingInstance = loadingService()
        appApi
          .createTemplate(this.templateData, this.createAppId)
          .then(() => {
            this.$message.success("创建成功")
            this.refresh()
            this.createVisible = false
          })
          .finally(() => loadingInstance.close())
      })
    },
    handleTableCommand(command, app) {
      switch (command) {
        case "deleteApp":
          this.$refs.deleteTemplateDialog.init(app)
          break
      }
    },
    search() {
      this.filterData = this.template.filter(i => stringIncludes(i.name, this.searchText))
    },
    publish(row) {
      this.$refs.settingTemplateDialog.open(this._.cloneDeep(row), true)
    },
    toManageApp(app) {
      const { href } = this.$router.resolve({
        name: "worksheet",
        params: { appId: app.id },
        query: { template: true }
      })
      window.open(href)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-template {
  .title {
    font-size: $font-size-title-first;
    padding: 0 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .main {
    padding: 8px 0 0 22px;
    display: grid;

    .el-table {
      .app-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 73px;
        &:not(:last-child) {
          border-bottom: 1px solid #e4e4e4;
        }
        .app-icon {
          @include flex-center;
          flex-shrink: 0;
          box-sizing: border-box;
          width: 48px;
          height: 48px;
          background: rgba(248, 177, 116, 1);
          border-radius: 12px;
          margin-right: 24px;
          font-size: 28px;
          color: #fff;
        }
        .app-name {
          flex: auto;
        }
      }
    }
    .operate {
      display: flex;
      margin-left: auto;
      .input-search {
        width: 200px;
        height: 32px;
        border-radius: 6px;
        margin-right: 8px;
      }
      .button-new {
        width: 64px;
        height: 32px;
        background: #1989fa;
        border-radius: 4px;
        font-size: 14px;
        color: #ffffff;
        padding: 0;
        margin-right: 8px;
      }
      .button-popover {
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #a3d0fd;
        padding: 0;
      }
    }
  }
  .table-status {
    width: 60px;
    height: 25px;
    text-align: center;
    border-radius: 4px;
  }
  .orange {
    background-color: rgb(248, 193, 91);
  }
  .green {
    background-color: rgb(98, 245, 98);
  }
  .blue {
    background-color: rgb(71, 71, 245);
  }
  .table-wrapper {
    flex: 1;
    overflow: hidden;
    box-sizing: border-box;
  }
}
</style>
